// extracted by mini-css-extract-plugin
module.exports = {"expriy":"expriy","content":"content","title":"title","subtitle":"subtitle","bold":"bold","close-btn":"close-btn"};